import type { ScreeningDocument } from "@/services/api/guardiansv2/types";
import { screeningListSubtitle, screeningListTitle } from "./screeningPresentation";

function includesNeedle(haystack: string | null | undefined, needle: string): boolean {
  return (haystack ?? "").toLowerCase().includes(needle);
}

/** Client-side screening list search (title, subtitle, id, catalogue, check text). */
export function screeningMatchesSearch(screening: ScreeningDocument, q: string): boolean {
  if (!q.trim()) return true;
  const needle = q.toLowerCase();
  if (includesNeedle(screeningListTitle(screening), needle)) return true;
  if (includesNeedle(screeningListSubtitle(screening), needle)) return true;
  if (includesNeedle(screening._id, needle)) return true;
  if (includesNeedle(screening.catalogue_key, needle)) return true;
  const checks = screening.checks?.checks ?? [];
  return checks.some(
    (c) => includesNeedle(c.title, needle) || includesNeedle(c.summary, needle)
  );
}
